import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  Text,
  useToast
} from "@chakra-ui/react";
import { formatTextWithLineBreaks } from "../../utils/formatText";
import { fetchFormSubmit } from "../../services/webService";
import { sendFormSubmitMail } from "../../services/webService";

const ContactForm = ({ width, height, description, page='homepage' }) => {
  const toast = useToast();
  const [formData, setFormData] = useState({
    user_name: "",
    user_phone_number: "",
    user_location: "",
    user_email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    toast({
      title: "Sending...",
      description: "Your form is being submitted.",
      status: "info",
      duration: 5000,
      isClosable: true,
    });
    function getUTMParameters() {
      const params = new URLSearchParams(window.location.search);
      const utmParams = {
          utm_source: params.get('utm_source'),
          utm_campaign: params.get('utm_campaign'),
          utm_medium: params.get('utm_medium'),
          utm_adset: params.get('utm_adset'),
          utm_content: params.get('utm_content')
      };
      return utmParams;
  }

    const utmParams = getUTMParameters();
    const mergedData = {
        formData, 
        ...utmParams,
        page,
    };
    try {
      await fetchFormSubmit(JSON.stringify(mergedData));
    } catch (error) {
        console.error("Error submitting form:", error);
    }
    if(formData.user_email){
      try{
        await sendFormSubmitMail(JSON.stringify(formData))
      } catch(error){
        console.error('Error while trying to send email', error);
      }
    }

    const whatsappMessage = `שם: ${formData.user_name} פלאפון: ${formData.user_phone_number} אזור מגורים: ${formData.user_location} אימייל: ${formData.user_email} הודעה: ${formData.message}`;
    const whatsappUrl = `https://wa.me/972504555498?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    window.open(whatsappUrl, "_blank");

    setFormData({
      user_name: "",
      user_phone_number: "",
      user_location: "",
      user_email: "",
      message: "",
    });
    toast({
      title: "Form Sent!",
      description: "Your form has been successfully submitted.",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Box
      p={8}
      width={width}
      height={{ base: height / 2, md: height, lg: height }}
      borderWidth={1}
      borderRadius="lg"
      boxShadow="lg"
      fontSize="large"
      bgImage='url("https://leadguitar.s3.eu-north-1.amazonaws.com/images/formbg.png")'
      bgSize="cover"
      bgPosition="center"
      bgRepeat="no-repeat"
    >
      <form onSubmit={handleSubmit}>
        <VStack spacing={8} align="stretch">
          <Text fontSize={{base: '1rem', md: '1.2rem'}} textAlign="right" dir="rtl">
            {formatTextWithLineBreaks(description)}
          </Text>
          <FormControl id="name" isRequired>
            <FormLabel fontSize={{base: '1rem',md:"2.2vh"}} textAlign="right" dir="rtl" htmlFor="user_name">
              שם:
            </FormLabel>
            <Input
              type="text"
              name="user_name"
              id="user_name"
              value={formData.user_name}
              onChange={handleInputChange}
              placeholder="השם שלך"
              fontSize={{base: '1rem', md: '2.2vh'}}
              height="5vh"
              textAlign="right"
              dir="rtl"
            />
          </FormControl>
          <FormControl id="location" isRequired>
            <FormLabel fontSize={{base: '1rem',md:"2.2vh"}} textAlign="right" dir="rtl" htmlFor="user_location">
              אזור מגורים:
            </FormLabel>
            <Input
              type="text"
              name="user_location"
              id="user_location"
              value={formData.user_location}
              onChange={handleInputChange}
              placeholder="אזור המגורים שלך"
              fontSize={{base: '1rem', md: '2.2vh'}}
              height="5vh"
              textAlign="right"
              dir="rtl"
            />
          </FormControl>
          <FormControl id="phone" isRequired>
            <FormLabel fontSize={{base: '1rem',md:"2.2vh"}} textAlign="right" dir="rtl" htmlFor="user_phone_number">
              מספר פלאפון:
            </FormLabel>
            <Input
              type="text" 
              name="user_phone_number"
              id="user_phone_number"
              value={formData.user_phone_number}
              onChange={handleInputChange}
              placeholder="מספר הפלאפון שלך"
              fontSize={{base: '1rem', md: '2.2vh'}}
              height="5vh"
              textAlign="right"
              dir="rtl"
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel fontSize={{base: '1rem',md:"2.2vh"}} textAlign="right" dir="rtl" htmlFor="user_email">
              דואר אלקטרוני:
            </FormLabel>
            <Input
              type="text"
              name="user_email"
              id="user_email"
              value={formData.user_email}
              onChange={handleInputChange}
              placeholder="האימייל שלך"
              fontSize={{base: '1rem', md: '2.2vh'}}
              height="5vh"
              textAlign="right"
              dir="rtl"
            />
          </FormControl>
          <FormControl id="message" size="lg">
            <FormLabel fontSize={{base: '1rem',md:"2.2vh"}} textAlign="right" dir="rtl" htmlFor="user_message">
              הודעה:
            </FormLabel>
            <Textarea
              name="message"
              id="user_message"
              value={formData.message}
              onChange={handleInputChange}
              textAlign="right"
              placeholder="מה היית\ה רוצה לשפר בנגינה שלך?"
              fontSize={{base: '1rem', md: '2.2vh'}}
              size="lg"
              className="textarea-message"
              height={{lg: "14vh"}}
              dir="rtl"
            />
          </FormControl>
          <Button bg='#0e7f2a' _hover={{bg: '#42e362'}}  color="#ffffff" type="submit" dir="rtl">
            לשליחה בוואטסאפ
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default ContactForm;
